import { render } from "./legoTooltipExtendV2.vue?vue&type=template&id=27317fd1&scoped=true"
import script from "./legoTooltipExtendV2.vue?vue&type=script&lang=js"
export * from "./legoTooltipExtendV2.vue?vue&type=script&lang=js"

import "./legoTooltipExtendV2.vue?vue&type=style&index=0&id=27317fd1&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27317fd1"],['__file',"src/components/lego/extend/legoTooltipExtendV2.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "27317fd1"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('27317fd1', __exports__)) {
    api.reload('27317fd1', __exports__)
  }
  
  module.hot.accept("./legoTooltipExtendV2.vue?vue&type=template&id=27317fd1&scoped=true", () => {
    api.rerender('27317fd1', render)
  })

}


export default __exports__